import Card from '@/components/Card';
import { Switch } from '@/components/Controls/Switch';
import Loader from '@/components/Loading/Loader';
import { useUpdateGroup } from '@/hooks/group.hooks';
import { FormManagementProps } from '@/type/form.types';
import { useEffect } from 'react';
import { FieldValues, Path } from 'react-hook-form';

export const GroupReportDisplayManagement = <TSchema extends FieldValues>({
  t,
  data,
  watch,
  register,
  setValue,
  submitDisabled,
}: FormManagementProps<TSchema>) => {
  const { mutate: mutateUpdateGroup, isPending: isPendingUpdateGroup } =
    useUpdateGroup();

  /**
   * === Set Value Watchers section ===
   */
  const showReportEquipmentsValue =
    watch && watch('showReportEquipments' as Path<TSchema>);

  const showReportDamagesValue =
    watch && watch('showReportDamages' as Path<TSchema>);
  /**
   * === END OF Set Value Watchers section ===
   */

  /**
   * === Set Fields Initial Values section ===
   */
  useEffect(() => {
    if (setValue && data) {
      setValue(
        'showReportEquipments' as Path<TSchema>,
        data.showReportEquipments
      );
      setValue('showReportDamages' as Path<TSchema>, data.showReportDamages);
    }
  }, [setValue, data]);
  /**
   * === END OF Set Fields Initial Values section ===
   */

  return (
    <>
      <Card
        title={
          <div className="flex items-center gap-2">
            <i className="ki-filled ki-abstract-41 text-purple-500 text-[25px]" />
            <p>{t('informationDisplay')}</p>
          </div>
        }
      >
        <div className="flex gap-6">
          <Switch
            leftText={t('displayEquipments')}
            {...(register && register('showReportEquipments' as Path<TSchema>))}
            disabled={submitDisabled || isPendingUpdateGroup}
            checked={showReportEquipmentsValue}
            onChange={(e) => {
              mutateUpdateGroup({
                ...data,
                showReportEquipments: e.target.checked,
              });
            }}
          />
          <div className="font-medium text-gray-300">|</div>
          <Switch
            leftText={t('displayDamages')}
            {...(register && register('showReportDamages' as Path<TSchema>))}
            disabled={submitDisabled || isPendingUpdateGroup}
            checked={showReportDamagesValue}
            onChange={(e) => {
              mutateUpdateGroup({
                ...data,
                showReportDamages: e.target.checked,
              });
            }}
          />
        </div>
      </Card>
      {submitDisabled || (isPendingUpdateGroup && <Loader />)}
    </>
  );
};
